module.exports = __webpack_public_path__ + "img/41-03.bc165238.png";